export const replaceIncorrectSymbols = (string) => {
  return string.replace(/â€\x9D/, "").replace(/\//, "").replace("”", "")
}
